'use client';
import {
  MAIN_MENU_LIST,
  LIVE_CONTEXT_MENU,
  LIVE_SORT_OPTION,
} from '@/constants/main';
import {SectionHeader} from '@/components/main/common';
import {SoopLoadingSpinner, SoopUiSelectBox} from '@/components/ui';
import LiveBroadcastItem from '../MyPlus/LiveBroadcastItem';
import {BROADCAST_TYPES} from '@/constants';

const getMenuName = (selectedMenu) => {
  const menuItem = MAIN_MENU_LIST.find((item) => item.id === selectedMenu);
  return menuItem ? menuItem.name : '';
};

export const LiveGroupList = ({
  order,
  broadList,
  selectedMenu,
  selectedTitle,
  slicedBroadList,
  handleOnClickMore,
  handleOnClickSort,
  handleOnClickHiddenStreamer,
  location,
  isLoading,
}) => {
  const handleContextMenuClick = (event, type, data) => {
    if (type === 'hidden') {
      handleOnClickHiddenStreamer(data);
    }
  };

  return (
    <>
      <SectionHeader
        title={selectedTitle ? selectedTitle : getMenuName(selectedMenu)}
        rightElement={
          <SoopUiSelectBox
            options={LIVE_SORT_OPTION}
            type={order}
            onChange={handleOnClickSort}
          />
        }
      />
      {isLoading ? (
        <SoopLoadingSpinner />
      ) : (
        <>
          {broadList?.list?.length > 0 ? (
            <div className='cBox-list'>
              <ul>
                {broadList?.list?.map((broadcast, idx) => (
                  <li data-type='cBox' key={idx}>
                    <LiveBroadcastItem
                      broadcastType={BROADCAST_TYPES.LIVE}
                      location={location}
                      broadcastId={broadcast.broadNo}
                      thumbnailUrl={broadcast.broadThumb}
                      userId={broadcast.userId}
                      userNickname={broadcast.userNick}
                      viewCount={broadcast.totalViewCnt}
                      liveType={broadcast.broadType}
                      title={broadcast.broadTitle}
                      categoryName={broadcast.categoryName}
                      categoryNo={broadcast.broadCateNo}
                      categoryTags={broadcast.categoryTags}
                      autoHashTags={broadcast.autoHashtags}
                      hashTags={broadcast.hashTags}
                      canResend={Boolean(Number(broadcast.visitBroadType))}
                      allowsAdult={Number(broadcast.broadGrade) === 19}
                      startDateTime={broadcast.broadStart}
                      hasDrops={Boolean(broadcast.isDrops)}
                      hasPassword={broadcast.isPassword === 'Y'}
                      handleMenuClicked={handleContextMenuClick}
                      contextMenu={{
                        menuList: LIVE_CONTEXT_MENU,
                      }}
                      subscriptionOnly={broadcast.subscriptionOnly}
                    />
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <div className='nt_area'>
              <p>진행중인 라이브가 없습니다.</p>
            </div>
          )}
        </>
      )}

      {broadList.isMore || (slicedBroadList && slicedBroadList.length > 0) ? (
        <div className='show_more'>
          <button type='button' onClick={() => handleOnClickMore()}>
            더보기
          </button>
        </div>
      ) : null}
    </>
  );
};
